import e from "react";
import { Overlay as d } from "../../../Overlay/Overlay.js";
import { OverflowContent as f } from "./OverflowContent.js";
const m = _ref => {
  let {
    wrapperRef: n,
    openSubMenu: a,
    accountInfo: r,
    fixed: o,
    hasNavbar: t
  } = _ref;
  const {
    userName: l
  } = r;
  return e.createElement(e.Fragment, null, e.createElement(d, {
    open: a
  }), e.createElement("ul", {
    id: "ds-overflow-menu",
    "aria-hidden": !a,
    "data-expanded": a,
    "data-fixed": o,
    "data-islogged": !!l,
    "data-hasnavbar": t,
    ref: n,
    "data-testid": "overflow-menu",
    className: "olx-header__overflow"
  }, e.createElement(f, {
    accountInfo: r,
    hasNavbar: t,
    openSubMenu: a
  })));
};
export { m as DefaultOverflowMenu };